import {
  AutoLockFormsLevelType,
  DenialReasonsFieldNames,
  FormNames,
} from '../autoLockForms.constants';

const formFields = [
  {
    name: DenialReasonsFieldNames.NEW_DENIAL_REASON,
    label: 'Select Denial Reason',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: DenialReasonsFieldNames.BORROWER_SELECTION,
    label: 'Borrower Selection',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const denialReasonsForm = {
  name: FormNames.DENIAL_REASONS,
  label: 'Denial Reasons',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
